const fromSemverToVersion = (semver: string): number => {
  const [major, minor, patch] = semver.split(".")

  // Validate the constraints
  const majorNum = parseInt(major || "0", 10)
  const minorNum = parseInt(minor || "0", 10)
  const patchNum = parseInt(patch || "0", 10)

  if (majorNum >= 10 || minorNum >= 10 || patchNum >= 100) {
    throw new Error(
      "Invalid version: major and minor must be < 10, patch must be < 100"
    )
  }

  return majorNum * 1000 + minorNum * 100 + patchNum
}

export { fromSemverToVersion }
